import React from 'react';
import styles from './GeneralInfoCommentIcon.module.scss';
import { useCommentCount } from '../hooks';

interface GeneralInfoCommentIconProps {
  phaseName?: string;
  categoryName?: string;
  className?: string;
  onClick?: (event?: React.MouseEvent) => void;
}

const GeneralCommentIcon: React.FC<GeneralInfoCommentIconProps> = ({
  phaseName,
  categoryName,
  className,
  onClick
}) => {
  const { totalCommentCount } = useCommentCount(phaseName, categoryName);

  // Helper function to format count with "99+" for large numbers
  const formatCount = (count: number): string => {
    return count > 99 ? '99+' : count.toString();
  };

  // Helper function to render the comment icon button
  const renderCommentIcon = (
    iconColor: string,
    count: number,
    ariaLabel: string
  ) => (
    <div className={`${styles.container} ${className || ''}`}>
      <button
        className={styles.iconButton}
        onClick={event => {
          event.stopPropagation();
          onClick?.(event);
        }}
        type="button"
        aria-label={ariaLabel}
      >
        <div className={styles.iconWrapper}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.commentIcon}
          >
            <path
              d="M14.25 0H3.75C1.68213 0 0 1.68262 0 3.75V9.25C0 11.3174 1.68213 13 3.75 13H5.25V16.25C5.25 16.5508 5.42968 16.8223 5.70654 16.9404C5.80127 16.9805 5.90088 17 6 17C6.19043 17 6.37744 16.9277 6.52002 16.79L10.457 13H14.25C16.3179 13 18 11.3174 18 9.25V3.75C18 1.68262 16.3179 0 14.25 0Z"
              fill={iconColor}
            />
            <text
              x="9"
              y="7.5"
              textAnchor="middle"
              dominantBaseline="middle"
              fill="white"
              fontSize="9"
              fontWeight="bold"
              fontFamily="Adobe Clean, sans-serif"
            >
              {count > 0 && formatCount(count)}
            </text>
          </svg>
        </div>
      </button>
    </div>
  );

  if (totalCommentCount > 0) {
    return renderCommentIcon(
      '#0265DC',
      totalCommentCount,
      `You have (${totalCommentCount}) Mentions`
    );
  }

  return renderCommentIcon(
    '#909090',
    totalCommentCount,
    `You have (${totalCommentCount}) Mentions`
  );
};

export default GeneralCommentIcon;
